import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { DateTime } from 'luxon';
import { FC } from 'react';
import { MdCloudDone, MdCloudOff, MdCloudUpload } from 'react-icons/md';

interface DraftStatusProps {
  isSaving: boolean;
  isError: boolean;
  /** When this page last saved the draft. */
  lastSavedAt: Date | null;
  /** A draft was already saved before the page opened. */
  hasDraft: boolean;
}

/** Shows the teacher that the feedback draft is saved, so they can leave and come back. */
export const DraftStatus: FC<DraftStatusProps> = ({ isSaving, isError, lastSavedAt, hasDraft }) => {
  const state = isSaving
    ? { icon: <MdCloudUpload />, text: 'Saving draft…', color: 'text.secondary' }
    : isError
      ? { icon: <MdCloudOff />, text: 'Draft not saved. Check your connection.', color: 'error.main' }
      : lastSavedAt
        ? {
            icon: <MdCloudDone />,
            text: `Draft saved at ${DateTime.fromJSDate(lastSavedAt).toLocaleString(DateTime.TIME_SIMPLE)}`,
            color: 'success.main',
          }
        : hasDraft
          ? { icon: <MdCloudDone />, text: 'Draft saved. Not sent to the student yet.', color: 'text.secondary' }
          : null;

  if (!state) {
    return null;
  }
  return (
    <Box display="flex" alignItems="center" gap={0.5} color={state.color} role="status" aria-live="polite">
      {state.icon}
      <Typography variant="caption" color="inherit">
        {state.text}
      </Typography>
    </Box>
  );
};
